module.exports = __webpack_public_path__ + "static/media/jyrki.varvas.69ea0266.jpg";